function groupArrayOfObjectsBy(list: any[], key: string) {
    return list.reduce(function (runningGroupedList, currentListItem) {
        (runningGroupedList[currentListItem[key]] = runningGroupedList[currentListItem[key]] || []).push(currentListItem);
        return runningGroupedList;
    }, {});
};

export default groupArrayOfObjectsBy;